import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../utils/api";
import { useApp } from "../context/AppContext";
import { t } from "../utils/i18n";
import { GardenIcon, WishIcon, ThoughtIcon, EmotionIcon, DreamIcon, MemoryIcon, SecretIcon, DesireIcon, SharedGardenIcon } from "../components/GardenIcons";

const CATEGORIES = [
  { key: "wish", path: "wish", Icon: WishIcon, i18nKey: "garden_cat_wishes" },
  { key: "thought", path: "thought", Icon: ThoughtIcon, i18nKey: "garden_cat_thoughts" },
  { key: "emotion", path: "emotion", Icon: EmotionIcon, i18nKey: "garden_cat_emotions" },
  { key: "dream", path: "dream", Icon: DreamIcon, i18nKey: "garden_cat_dreams" },
  { key: "memory", path: "memory", Icon: MemoryIcon, i18nKey: "garden_cat_memories" },
  { key: "secret", path: "secret", Icon: SecretIcon, i18nKey: "garden_cat_secrets" },
  { key: "desires", path: "desires", Icon: DesireIcon, i18nKey: "garden_cat_desires" },
];

// Page d'accueil du Jardin Secret — épurée à dessein (titre + tagline + grille de cartes), aucune
// identité graphique propre : mêmes cartes (borderRadius 16, border 1px #F0F0F0) que partout
// ailleurs dans OLTODO.
export default function Garden() {
  const navigate = useNavigate();
  const { lang } = useApp();
  const [gardens, setGardens] = useState<any[] | null>(null);

  useEffect(() => {
    api.get("/garden/gardens/mine").then(d => setGardens(d?.gardens || [])).catch(() => setGardens([]));
  }, []);

  return (
    <div style={{ maxWidth: 560, margin: "0 auto", padding: 20 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 4 }}>
        <button onClick={() => navigate(-1)} style={{ border: "none", background: "none", cursor: "pointer", fontSize: 20, color: "#666" }}>←</button>
        <span style={{ fontSize: 20, fontWeight: 700 }}>{t(lang, "garden_title")}</span>
      </div>
      <div style={{ fontSize: 13, color: "#999", marginBottom: 28, marginLeft: 32 }}>{t(lang, "garden_tagline")}</div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        {CATEGORIES.map(c => (
          <div key={c.key} onClick={() => navigate(`/garden/${c.path}`)} style={{ border: "1px solid #F0F0F0", borderRadius: 16, padding: 18, cursor: "pointer", display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ width: 40, height: 40, borderRadius: 20, backgroundColor: "#F5F5F5", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <c.Icon size={19} color="#0a0a0a" />
            </div>
            <span style={{ fontSize: 14, fontWeight: 700 }}>{t(lang, c.i18nKey)}</span>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 28, paddingTop: 24, borderTop: "1px solid #F0F0F0" }}>
        <div
          onClick={() => navigate("/notre-jardin")}
          style={{ display: "flex", alignItems: "center", gap: 14, border: "1px solid #F0F0F0", borderRadius: 16, padding: 16, cursor: "pointer" }}
        >
          <div style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: "#F5F5F5", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <SharedGardenIcon size={20} color="#0a0a0a" />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 700 }}>{t(lang, "garden_notre_jardin_title")}</div>
            <div style={{ fontSize: 12, color: "#999", marginTop: 2 }}>
              {gardens === null ? "…" : gardens.length > 0
                ? `${gardens.filter(g => g.my_status === "active").length} · ${gardens.map(g => g.name).slice(0, 1).join(", ")}`
                : t(lang, "garden_notre_jardin_empty")}
            </div>
          </div>
          <GardenIcon size={16} color="#ccc" />
        </div>
      </div>
    </div>
  );
}
